export default __webpack_public_path__ + "assets/png/243a4cbbc15eb6f70c216a903f082289.png";